import {
    Box, Stack, Icon,
    AppBar, Toolbar,
    IconButton, Divider
} from '@mui/material'

import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useAppDrawer } from '@services/hooks/AppDrawer'
import { createId } from '@services/utils'
import { useWidth } from '@services/hooks/Width'

import Link from './Link'
import Submenu from './Submenu'
import Universe from './Universe'

import Schema from '@features/menu/header.json'
import productLogo from '@components/Theme/Logo/product.svg'

import RightMenuHeader from '@features/menu/rightMenuHeader'

import logo from '@components/media/logo.png'
import Config from '@features/config.json'
import Styles from './style'

export const Header = () => {
    const url = useLocation()
    const pathname = url.pathname

    const { show: showDrawer, hide: hideDrawer, config: drawerConfig } = useAppDrawer()
    const width = useWidth()

    const haveDrawer = useRef((Config.interface?.leftPanel ?? true))
    const showMenuButton = useRef()
    showMenuButton.current = (width !== 'xl')

    const [menuItems, setMenuItems] = useState([])
    const [uname, setUname] = useState('-')
    const [selectedUniverse, setSelectedUniverse] = useState(-1)

    const handleMenuVisibility = () => {
        if (drawerConfig.display) hideDrawer()
        else showDrawer()
    }

    useEffect(() => {
        if (!Schema.products && Schema.items?.length > 0)
            setMenuItems(Schema.items)
    }, [])

    useEffect(() => {
        if (!Schema.products) return

        const universePath = pathname.split('/')[1];
        let found = false

        for (let i = 0; i < Schema.products.length; i++) {
            for (let j = 0; j < Schema.products[i].universe.length; j++) {
                if (universePath === Schema.products[i].universe[j]) {
                    found = true
                    setUname(Schema.products[i].label)
                    setMenuItems(Schema.products[i].items)
                    setSelectedUniverse(i)
                    break;
                }
            }
            if (found) break
        }
    }, [pathname])

    return (
        <AppBar elevation={0} sx={Styles.root}>
            <Toolbar sx={{justifyContent: 'space-between'}}>
                {haveDrawer.current && showMenuButton.current && (
                    <Box sx={Styles.menu} whiteSpace={4}>
                        <IconButton onClick={handleMenuVisibility} sx={Styles.mainMenu}>
                            <Icon>menu</Icon>
                        </IconButton>
                    </Box>
                )}

                <Stack direction={'row'} spacing={2} alignItems={'center'} sx={Styles.product}>
                    <img src={productLogo} alt={'product'} />
                    <Divider orientation={'vertical'} variant={'middle'} flexItem/>
                    {!Schema.products && (<span className={'nunito'}>{Schema.product}</span>)}
                    {Schema.products?.length > 0 && (<Universe uname={uname} products={Schema.products} selected={selectedUniverse} />)}
                </Stack>

                <Stack direction={'row'} spacing={2} alignItems={'center'} sx={Styles.links}>
                    {menuItems && menuItems.length > 0 && menuItems.map(item => {
                        const key = createId()
                        if (item.items && item.items?.length > 0)
                            return (<Submenu disabled={item.disabled} label={item.label} items={item.items} key={key} />)
                        return (<Link disabled={item.disabled} label={item.label} path={item.path} target={item.target} key={key} />)
                    })}
                </Stack>

                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={Styles.right}>
                    <RightMenuHeader/>
                    <img src={logo} alt='TOTAL ENERGIES'/>
                </Stack>
            </Toolbar>
        </AppBar>
    )
}

export default Header
